import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import WrapperModalPortal from './WrapperModalPortal';
import classnames from 'classnames';
import css from './modal.module.scss';
const ModalPortal = ({
    children,
    customStyle = {},
    customClass = '',
    closeHandler,
    fullWidth,
    fullHeight,
    unscrollable = true
}) => {
    const { wrapChildrenStyle = {}, wrapModalStyle = {} } = customStyle;

    const customClasses = useMemo(
        () =>
            customClass && typeof customClass === 'string'
                ? customClass.split(' ').map((classname) => classnames(css[classname], classname))
                : false,
        [customClass]
    );
    return ReactDOM.createPortal(
        <WrapperModalPortal unscrollable={unscrollable}>
            <div
                {...{ 'data-scroll': true }}
                style={{ ...wrapModalStyle }}
                className={classnames(customClasses || css.modal)}
                onClick={(e) => {
                    if (e.target === e.currentTarget && closeHandler) {
                        closeHandler && closeHandler(e);
                    }
                }}
            >
                <div
                    style={{
                        ...(fullWidth && { width: '100%' }),
                        ...(fullHeight && { height: '100%' }),
                        ...{ maxWidth: '100%' },
                        ...{ maxHeight: '100%' },
                        ...wrapChildrenStyle
                    }}
                    className='scrollbar-hidden'
                >
                    {children}
                </div>
            </div>
        </WrapperModalPortal>,
        document?.body
    );
};
ModalPortal.propTypes = {
    customClass: PropTypes.string,
    closeHandler: PropTypes.func,
    fullWidth: PropTypes.bool,
    fullHeight: PropTypes.bool
};
export default ModalPortal;
